import { render, staticRenderFns } from "./cl-reminder.vue?vue&type=template&id=858a735a&scoped=true&"
import script from "./cl-reminder.vue?vue&type=script&lang=ts&"
export * from "./cl-reminder.vue?vue&type=script&lang=ts&"
import style0 from "./cl-reminder.vue?vue&type=style&index=0&id=858a735a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858a735a",
  null
  
)

export default component.exports